import {
  Box,
  Card,
  Grid,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import 'swiper/css';
import 'swiper/css/free-mode';

import FlexBox from 'components/flexbox/FlexBox';
import KakaoLoginModal from 'components/modal/kakaoLoginModal';
import Footer from 'page-sections/callmetellme/Footer';
import CallmeTellmeBottomBar from '../../../page-sections/callmetellme/CallmeTellmeBottomBar';
import MyCommentsSection from '../../../page-sections/callmetellme/mypage/MyCommentsSection';
import MypageMenuCard from '../../../page-sections/callmetellme/MypageMenuCard';
import TitleCard from '../../../page-sections/callmetellme/TitleCard';

export default function CommentsOnMyPosts() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('xl'));

  const [showKaKaoLoginModal, setShowKaKaoLoginModal] = useState(false);

  let padding;
  if (window.innerWidth > 1720 && !isTablet) {
    padding = '0px 0px';
  } else {
    padding = isTablet ? '0px 15px' : '0px 0px';
  }

  const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    padding: padding,
    backgroundColor: theme.palette.primary.lightGrey200,
    borderRadius: 0,
    border: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      '& > .MuiBox-root': {
        paddingBottom: 0,
      },
    },
  }));

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.lightGrey200,
        overflow: 'visible',
      }}
    >
      <KakaoLoginModal
        showModal={showKaKaoLoginModal}
        setShowModal={setShowKaKaoLoginModal}
      />

      {isMobile && <CallmeTellmeBottomBar />}

      <Grid
        container
        xs={12}
        gap={2}
        paddingX={!isDesktop ? '0px' : '180px'}
        justifyContent={'center'}
        sx={{ overflow: 'visible' }}
      >
        {!isTablet && (
          <Grid
            item
            xs={12}
            lg={2.5}
            sx={{
              position: 'sticky',
              top: '76px',
              alignSelf: 'flex-start',
              height: 'fit-content',
              width: '100%',
            }}
          >
            <Box
              sx={{
                width: '100%',
                padding: isTablet ? '15px 0px 0px 0px' : '20px 0px 20px 0px',
                backgroundColor: theme.palette.primary.lightGrey200,
                borderRadius: 0,
                border: 'none',
                [theme.breakpoints.down('sm')]: {
                  '& > .MuiBox-root': {
                    paddingBottom: 0,
                  },
                },
              }}
            >
              <FlexBox gap={2} flexDirection={'column'}>
                <MypageMenuCard />
              </FlexBox>
            </Box>
          </Grid>
        )}

        <Grid item xs={12} lg={9.3} sx={{ overflow: 'visible' }}>
          <Grid container spacing={isTablet ? 2.5 : 2}>
            <Grid item xs={12}>
              <TitleCard title="내 게시글에 달린 댓글" />
            </Grid>
            <Grid item xs={12}>
              <StyledCard
                sx={{
                  border: 'none',
                  overflow: 'visible',
                }}
              >
                <Grid
                  container
                  sx={{
                    width: '100%',
                    overflow: 'visible',
                  }}
                >
                  <MyCommentsSection
                    title="내 게시글에 달린 댓글"
                    isTablet={isTablet}
                    isMobile={isMobile}
                  />
                </Grid>
              </StyledCard>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Box paddingBottom={isMobile ? '60px' : '0px'} backgroundColor="#EAEAEA">
        <Footer />
      </Box>
    </Box>
  );
}
